import React from 'react';
import { useDispatch } from 'react-redux';
import { IRefIds } from 'constants/refs';
import { tabsOpened } from 'store/actions/tabs';
import styled from 'styled-components';

interface IIdButtonProps {
  id: number;
  refId: IRefIds;
  courseId: number;
  onClick?: () => void;
  label?: string;
}

const IdButton: React.FC<IIdButtonProps> = ({ id, refId, courseId, onClick, label }) => {
  const dispatch = useDispatch();

  const handleClick = () => {
    if (onClick) {
      onClick();
    }
    dispatch(
      tabsOpened({
        refId: refId === IRefIds.vocs ? IRefIds.vocsCourse : refId,
        search: id.toString(),
        courseId: courseId,
      }),
    );
  };

  return <StyledIdButton onClick={handleClick}>{label ?? id}</StyledIdButton>;
};

const StyledIdButton = styled.div`
  float: right;
  margin: 3px;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;
`;

export default IdButton;
